module.exports = __webpack_public_path__ + "static/media/4-green.f74b33bf.svg";